//import { SortableElement } from 'react-sortable-hoc';
import SortableElement from "./sortable";

import Card from "./card";
import List from "./list";
import Panel from "./panel";
import Tile from "./tile";
import LargeTile from "./large-tile";
import Assortment from "./assortment";

export const PanelView = Panel;
export const SortablePanelView = SortableElement(Panel);
SortablePanelView.height = Panel.height;
SortablePanelView.width = Panel.width;
SortablePanelView.horizontalOffset = Panel.horizontalOffset;
SortablePanelView.verticalOffset = Panel.verticalOffset;

export const CardView = Card;
export const SortableCardView = SortableElement(Card);
SortableCardView.height = Card.height;
SortableCardView.width = Card.width;
SortableCardView.horizontalOffset = Card.horizontalOffset;
SortableCardView.verticalOffset = Card.verticalOffset;

export const TileView = Tile;
export const SortableTileView = SortableElement(Tile);
SortableTileView.height = Tile.height;
SortableTileView.width = Tile.width;
SortableTileView.horizontalOffset = Tile.horizontalOffset;
SortableTileView.verticalOffset = Tile.verticalOffset;

export const LargeTileView = LargeTile;
export const SortableLargeTileView = SortableElement(LargeTile);
SortableLargeTileView.height = LargeTile.height;
SortableLargeTileView.width = LargeTile.width;
SortableLargeTileView.horizontalOffset = LargeTile.horizontalOffset;
SortableLargeTileView.verticalOffset = LargeTile.verticalOffset;

export const ListView = List;
export const SortableListView = SortableElement(List);
SortableListView.height = List.height;
SortableListView.width = List.width;
SortableListView.horizontalOffset = List.horizontalOffset;
SortableListView.verticalOffset = List.verticalOffset;

export const AssortmentView = Assortment;
export const SortableAssortmentView = SortableElement(Assortment);
SortableAssortmentView.height = Assortment.height;
SortableAssortmentView.width = Assortment.width;
SortableAssortmentView.horizontalOffset = Assortment.horizontalOffset;
SortableAssortmentView.verticalOffset = Assortment.verticalOffset;

const views = {
    panel: [PanelView, SortablePanelView],
    card: [CardView, SortableCardView],
    tile: [TileView, SortableTileView],
    largeTile: [LargeTileView, SortableLargeTileView],
    list: [ListView, SortableListView],
    assortment: [AssortmentView, SortableAssortmentView],
};

export default views;
